const fonts = {
	latoBold: '../../assets/fonts/Lato-Bold.ttf',
	lato: '../../assets/fonts/Lato-Regular.ttf',
	latoLight: '../../assets/fonts/Lato-Light.ttf',
};

export default fonts;
